module.exports = __webpack_public_path__ + "static/media/pl.f4c20439.svg";